import { BetStatus } from '@pascal/pascal-core';
import { AllMarketTypes, BetTypeCalculationTypes, CardTypesReverse } from '../enums';
import {
  cardTypeParser,
  getBetCalculationType,
  getCardColor,
  toTwoBetTypeType,
  toMultiSelection,
} from '../helpers';

class DemoWinningService {
  calculateFinishedBetData(bet, cardType) {
    const betCopy = { ...bet, cardResult: cardType };
    const calculationType = getBetCalculationType(bet.betData);
    const cardNumber = cardTypeParser(cardType);
    const cardColor = getCardColor(cardType);
    switch (calculationType) {
      case BetTypeCalculationTypes.Hi:
      case BetTypeCalculationTypes.Lo:
        return this._hiLoCalculationStrategy(betCopy, cardNumber, calculationType);
      case BetTypeCalculationTypes.Colors:
        return this._colorsCalculationStrategy(betCopy, cardNumber, cardColor);
      case BetTypeCalculationTypes.ExactCard:
        return this._exactCardCalculationStrategy(betCopy, cardNumber);
      case BetTypeCalculationTypes.ExactCardWithColor:
        return this._exactCardWithColorCalculationStrategy(betCopy, cardNumber, cardColor);
      case BetTypeCalculationTypes.MultiSelection:
        return this._multiSelectionCalculationStrategy(betCopy, cardNumber);
      default:
        return this._hiLoCalculationStrategy(betCopy, cardNumber, calculationType);
    }
  }

  getWinLoseStatus(bet, status) {
    const betCopy = { ...bet, betResult: status };
    if (status === BetStatus.Win) {
      betCopy.winingAmount = bet.amount * bet.odd;
    } else if (status === BetStatus.Lose) {
      betCopy.winingAmount = 0;
    }
    return betCopy;
  }

  _hiLoCalculationStrategy(bet, cardNumber, calculationType) {
    if (cardNumber === cardTypeParser(0)) {
      return this.getWinLoseStatus(bet, BetStatus.Lose);
    }

    switch (calculationType) {
      case BetTypeCalculationTypes.Hi:
        if (cardNumber > bet.number) {
          return this.getWinLoseStatus(bet, BetStatus.Win);
        }
        return this.getWinLoseStatus(bet, BetStatus.Lose);
      case BetTypeCalculationTypes.Lo:
        if (cardNumber < bet.number) {
          return this.getWinLoseStatus(bet, BetStatus.Win);
        }
        return this.getWinLoseStatus(bet, BetStatus.Lose);
      default:
        return this.getWinLoseStatus(bet, BetStatus.Pending);
    }
  }

  _colorsCalculationStrategy(bet, cardNumber, cardColor) {
    if (cardNumber === AllMarketTypes.Joker) {
      return this.getWinLoseStatus(bet, BetStatus.Lose);
    }

    if (bet.betData === cardColor) {
      return this.getWinLoseStatus(bet, BetStatus.Win);
    }
    return this.getWinLoseStatus(bet, BetStatus.Lose);
  }

  _exactCardCalculationStrategy(bet, cardNumber) {
    if (bet.betData === AllMarketTypes.Joker && cardNumber === cardTypeParser(0)) {
      return this.getWinLoseStatus(bet, BetStatus.Win);
    }
    if (bet.number === cardNumber) {
      return this.getWinLoseStatus(bet, BetStatus.Win);
    }
    return this.getWinLoseStatus(bet, BetStatus.Lose);
  }

  _exactCardWithColorCalculationStrategy(bet, cardNumber, cardColor) {
    const betCardType = CardTypesReverse[bet.betData];
    const betColor = getCardColor(betCardType);

    if (bet.number === cardNumber && betColor === cardColor) {
      return this.getWinLoseStatus(bet, BetStatus.Win);
    }
    return this.getWinLoseStatus(bet, BetStatus.Lose);
  }

  _multiSelectionCalculationStrategy(bet, cardNumber) {
    switch (bet.betData) {
      case AllMarketTypes.J_Q:
      case AllMarketTypes.K_A:
        if (bet.betData === toTwoBetTypeType(cardNumber)) {
          return this.getWinLoseStatus(bet, BetStatus.Win);
        }
        return this.getWinLoseStatus(bet, BetStatus.Lose);
      case AllMarketTypes.Numbers_2_to_9:
      case AllMarketTypes.J_Q_K_A:
        if (bet.betData === toMultiSelection(cardNumber)) {
          return this.getWinLoseStatus(bet, BetStatus.Win);
        }
        return this.getWinLoseStatus(bet, BetStatus.Lose);
      default:
        return this.getWinLoseStatus(bet, BetStatus.Lose);
    }
  }
}

const demoWinningService = new DemoWinningService();

export { demoWinningService };
